import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    meta: {
      title: 'Customer Returns',
    },
    component: () => import(/* webpackChunkName: "Home" */ '../views/Home.vue'),
  },
  {
    path: '/step1',
    name: 'Step1',
    meta: {
      title: 'Customer Returns',
    },
    component: () => import(/* webpackChunkName: "Step1" */ '../views/Step1.vue'),
  },
  {
    path: '/step2',
    name: 'Step2',
    meta: {
      title: 'Customer Returns',
    },
    component: () => import(/* webpackChunkName: "Step2" */ '../views/Step2.vue'),
  },
  {
    path: '/step3',
    name: 'Step3',
    meta: {
      title: 'Customer Returns',
    },
    component: () => import(/* webpackChunkName: "Step3" */ '../views/Step3.vue'),
  },
  {
    path: '/step4',
    name: 'Step4',
    meta: {
      title: 'Customer Returns',
    },
    component: () => import(/* webpackChunkName: "Step4" */ '../views/Step4.vue'),
  },
  {
    path: '/step5',
    name: 'Step5',
    meta: {
      title: 'Customer Returns',
    },
    component: () => import(/* webpackChunkName: "Step5" */ '../views/Step5.vue'),
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    meta: {
      title: 'Customer Returns',
    },
    component: () => import(/* webpackChunkName: "PrivacyPolicy" */ '../views/PrivacyPolicy.vue'),
  },
  {
    path: '/terms-and-conditions',
    name: 'TermsAndConditions',
    meta: {
      title: 'Customer Returns',
    },
    component: () =>
      import(/* webpackChunkName: "TermsAndConditions" */ '../views/TermsAndConditions.vue'),
  },
  {
    path: '/contact-us',
    name: 'ContactUs',
    meta: {
      title: 'Customer Returns',
    },
    component: () => import(/* webpackChunkName: "ContactUs" */ '../views/ContactUs.vue'),
  },
]

const router = new VueRouter({
  routes,
})

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0)
  document.title = to.meta.title
  next()
})

export default router
